import { render, staticRenderFns } from "./ColumnDetails.vue?vue&type=template&id=3b8e4466&scoped=true&"
import script from "./ColumnDetails.vue?vue&type=script&lang=js&"
export * from "./ColumnDetails.vue?vue&type=script&lang=js&"
import style0 from "./ColumnDetails.vue?vue&type=style&index=0&id=3b8e4466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8e4466",
  null
  
)

export default component.exports